import React from "react";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  "@keyframes ldsFade": {
    "0%": { opacity: 0.2 },
    "40%": { opacity: 1 },
    "80%": { opacity: 0.2 },
    "100%": { opacity: 0.2 },
  },

  root: (props) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: `calc(${props.size}px / 2.5)`,
    lineHeight: 0,
    color: props.color || theme.palette.text.primary,
    "--dot-size": `${props.size}px`,
  }),

  dot: {
    display: "inline-block",
    width: "var(--dot-size)",
    height: "var(--dot-size)",
    borderRadius: "50%",
    backgroundColor: "currentColor",
    opacity: 0.2,
    animationName: "$ldsFade",
    animationDuration: "1.4s",
    animationTimingFunction: "ease-in-out",
    animationIterationCount: "infinite",
  },

  dot1: {
    animationDelay: "0s",
  },
  dot2: {
    animationDelay: "0.2s",
  },
  dot3: {
    animationDelay: "0.4s",
  },
}));

/**
 *
 * @param {number} size
 * @param {string} color
 */

// eslint-disable-next-line require-jsdoc
const LoadingDots = ({ size = 18, color, className = "", ariaLabel = "Loading" }) => {
  const classes = useStyles({ size, color });

  return (
    <Box component="span" className={`${classes.root} ${className}`} role="status" aria-label={ariaLabel}>
      <span className={`${classes.dot} ${classes.dot1}`} />
      <span className={`${classes.dot} ${classes.dot2}`} />
      <span className={`${classes.dot} ${classes.dot3}`} />
    </Box>
  );
};

LoadingDots.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
};
export default LoadingDots;
